import axios from 'axios'
import { services } from './'

const OUTAGE_API_URL = process.env.REACT_APP_OUTAGE_API
const OUTAGE_API_CLIENT_ID = process.env.REACT_APP_OUTAGE_CLIENT_ID
const OUTAGE_API_CLIENT_SECRET = process.env.REACT_APP_OUTAGE_CLIENT_SECRET
const ASSET_API_CLIENT_ID = process.env.REACT_APP_ASSET_CLIENT_ID
const ASSET_API_CLIENT_SECRET = process.env.REACT_APP_ASSET_CLIENT_SECRET
const ASSET_RADIUS = process.env.REACT_APP_OUTAGE_RADIUS_API

const INVENTORY_API_CLIENTID = process.env.REACT_APP_INVENTORY_CLIENTID
const INVENTORY_API_CLIENT_SECRET=process.env.REACT_APP_INVENTORY_CLIENT_SECRET
const ACCOUNT_LIST_API_URL = process.env.REACT_APP_INVENTORY_ACCOUNTLIST
const REFERENCE_LIST_API_URL = process.env.REACT_APP_INVENTORY_REFERENCENUMBERLIST
const INVENTORY_REPORT_API_URL = process.env.REACT_APP_INVENTORY_REPORT_API
const INVENTORY_REPORT_ASSETS = process.env.REACT_APP_INVENTORY_REPORT_ASSETS
const INVENTORY_REPORT_COMPONENTS = process.env.REACT_APP_INVENTORY_REPORT_COMPONENTS
const INVENTORY_EXPORT = process.env.REACT_APP_INVENTORY_EXPORT

export const outageDetails = (data,addressName,userComment,poleNum,jwt) => {
  const userData = {
    poleNumber: poleNum,
    address: addressName[0],
    city: addressName[1],
    lightType: data.lightType,
    problemType: data.problemType,
    comment: userComment,
    contactName: data.contactName,
    contactPhone: data.phoneNumber,
    contactEmailAddress: data.emailAddress,       
  }
  const config = {
    headers: {
      'Authorization': `Bearer ${jwt}`,
      'client_id':  OUTAGE_API_CLIENT_ID,
      'client_secret': OUTAGE_API_CLIENT_SECRET,
           
    },
  }
  return axios.post(
    `${OUTAGE_API_URL}`,
    userData,
    config
  )
}

export const AccountListData = () =>{
  const { auth } = services
  return auth.getAccessTokenOrLogin().then((token) =>{
    const { account } = token
    const config = {
      headers: {
        'Authorization': `Bearer ${token.accessToken}`,
        'client_id':  INVENTORY_API_CLIENTID,
        'client_secret': INVENTORY_API_CLIENT_SECRET,
        'objectId': account.idToken.sub,
               
      },
    }
    return axios.get(
      `${ACCOUNT_LIST_API_URL}`,
      config
    )
  })
}

export const getInventoryReport = (refNum) =>{
  const { auth } = services
  return auth.getAccessTokenOrLogin().then((token) =>{
    const config = {
      headers: {
        'Authorization': `Bearer ${token.accessToken}`,
        'client_id':  INVENTORY_API_CLIENTID,
        'client_secret': INVENTORY_API_CLIENT_SECRET,
        'referenceAccount': refNum,

      },
    }
    return axios.get(
      `${INVENTORY_REPORT_API_URL}`,
      config
    )
  })
}

export const ReferenceListData = (selectedAccount) =>{
  const { auth } = services
  return auth.getAccessTokenOrLogin().then((token) =>{
    const config = {
      headers: {
        'Authorization': `Bearer ${token.accessToken}`,
        'client_id':  INVENTORY_API_CLIENTID,
        'client_secret': INVENTORY_API_CLIENT_SECRET,
        'masterAccount' : selectedAccount,
      },
    }
    return axios.get(
      `${REFERENCE_LIST_API_URL}`,
      config
    )
  })
}

export const getRadiusAsset = (lat,lng) =>{
  const config = {
    headers: {
      'latitude' : lat,
      'longitude' : lng,
      'radius' : 1,
      'client_id':  ASSET_API_CLIENT_ID,
      'client_secret': ASSET_API_CLIENT_SECRET,
    },
  }
  return axios.get(
    `${ASSET_RADIUS}`,
    config
  )
 
}

export const getInventoryAssets = (referenceNumber) =>{
  const { auth } = services
  return auth.getAccessTokenOrLogin().then((token) =>{
    const config = {
      headers: {
        'referenceNumber': referenceNumber,
        'client_id':  INVENTORY_API_CLIENTID,
        'client_secret': INVENTORY_API_CLIENT_SECRET,
        'Authorization': `Bearer ${token.accessToken}`,
      },
    }
    return axios.get(
      `${INVENTORY_REPORT_ASSETS}`,
      config
    )
  })
}
export const downloadedFile = (refNums) => {
  const { auth } = services
  const refData = {
    "referenceAccount" : refNums,
  }
  return auth.getAccessTokenOrLogin().then((token) =>{
    const config = {
      headers: {
        'Authorization': `Bearer ${token.accessToken}`,
        'client_id':  INVENTORY_API_CLIENTID,
        'client_secret': INVENTORY_API_CLIENT_SECRET,
      },
    }
    return axios.post(
      `${INVENTORY_EXPORT}`,
      refData,
      config
    )
  })
}

export const getInventoryComponents = (locationID) =>{
  const { auth } = services
  return auth.getAccessTokenOrLogin().then((token) =>{
    const config = {
      headers: {
        'location_id': locationID,
        'Authorization': `Bearer ${token.accessToken}`,
        'client_id':  INVENTORY_API_CLIENTID,
        'client_secret': INVENTORY_API_CLIENT_SECRET,
      },
    }
    return axios.get(
      `${INVENTORY_REPORT_COMPONENTS}`,
      config
    )
  })
}